module.exports = __webpack_public_path__ + "static/media/NotoSansArabic-Bold.5caa99e4.ttf";